export default "__VITE_ASSET__DDqfCjBx__"